export default "__VITE_ASSET__Be048ZBq__"